import React from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import api from "../../api/Api";
import {WithContext as ReactTags} from 'react-tag-input';

import {withStyles} from '@material-ui/core/styles';
import {clinicmaster_id, getClinicUserId} from '../../util/globalHelper';


const KeyCodes = {
    comma: 188,
    enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];

function renderInput(inputProps) {
    const {classes, ref, ...other} = inputProps;

    return (
        <TextField
            fullWidth
            InputProps={{
                inputRef: ref,
                classes: {
                    input: classes.input,
                },
                ...other,
            }}
        />
    );
}

function renderSuggestion(suggestion, {query, isHighlighted}) {
    const matches = match(suggestion.user_id.name, query);
    const parts = parse(suggestion.user_id.name, matches);
    const mobileNo = suggestion.user_id.contact;
    const username = suggestion.user_id.name;
    const age = suggestion.user_id.age;
    const gender = suggestion.gender;
    return (
        <Card selected={isHighlighted} component="div" style={{margin: 0}}>
            <div style={{padding: "10px 15px"}}>
                <GridContainer key={Math.random()}>
                    <GridItem xs={6}>
                        <h4>{username}</h4>
                        <p>{age ? age + " years" : "NA"} {gender ? ", " + gender : ""}</p>
                    </GridItem>
                    <GridItem xs={6} style={{textAlign: "right"}}>
                        <h5>{mobileNo}</h5>
                    </GridItem>
                </GridContainer>
            </div>
        </Card>
    );
}

function renderSuggestionsContainer(options) {
    const {containerProps, children} = options;

    return (
        <Paper {...containerProps} square>
            {children}
        </Paper>
    );
}

const styles = theme => ({
    container: {
        flexGrow: 1,
        width: '100%',
        paddingTop: '27px',
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
    },
    suggestion: {
        display: 'block',
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
        height: '300px'
    },
});

class AutoCompletePatientForCampaign extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            // suggestions: [],
            suggestionsState: [],
            selected_PatientID: '',
            tags: [],
            suggestions: [
                {id: 'USA', text: 'USA'},
                {id: 'Germany', text: 'Germany'},
                {id: 'Austria', text: 'Austria'},
                {id: 'Costa Rica', text: 'Costa Rica'},
                {id: 'Sri Lanka', text: 'Sri Lanka'},
                {id: 'Thailand', text: 'Thailand'}
            ]
        };
        this.searchClick = this.searchClick.bind(this);
        this.getSuggestions = this.getSuggestions.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleAddition = this.handleAddition.bind(this);
        this.handleDrag = this.handleDrag.bind(this);
    }


    componentWillReceiveProps(nextProps) {
        if (this.props.tagsUser && this.props.tagsUser.length > 0) {
            this.setState({
                tags: nextProps.tagsUser
            })
        }
    }

    handleDelete(i) {
        const {tags} = this.state;
        this.setState({
            tags: tags.filter((tag, index) => index !== i),
        });
    }

    handleAddition(tag) {
        this.setState(state => ({tags: [...state.tags, tag]}), () => {
            this.props.getSuggestionValue(this.state.tags)
        });
    }

    handleDrag(tag, currPos, newPos) {
        const tags = [...this.state.tags];
        const newTags = tags.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);

        // re-render
        this.setState({tags: newTags});
    }


    getSuggestions(value) {
        {
            let inputValue = "";
            if (value) inputValue = value.trim().toLowerCase();
            let inputLength;
            if (inputValue) inputLength = inputValue.length;
            if (!(inputLength > 2))
                return [];
            var postBody = {
                "clinic_id": getClinicUserId() !== "" ? getClinicUserId() : this.props.clinic ? this.props.clinic : "",
                "clinic_master_id": clinicmaster_id() !== "" ? clinicmaster_id() : this.props.clinicmaster_id ? this.props.clinicmaster_id : "",
                "text": inputValue
            };
            return api.searchPatientsForCamapign(postBody).then((result) => {
                this.setState({
                    suggestions: result ? result.data.data.map(item => {
                        return {id: item.user_id._id, text: item.user_id.name}
                        // return item.user_id._id
                    }) : []
                });
            }).catch((err) => {
            })

        }

    }


    handleSuggestionsFetchRequested = ({value}) => {
        this.getSuggestions(value);
        this.setState({
            suggestions: this.getSuggestions(value),
        });
    };

    handleSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        });
    };

    handleChange = (event, {newValue}) => {
        this.setState({
            value: newValue,
        });
    };


    searchClick() {
        // console.log("This is what getting clicked", this.state);
    }

    render() {
        const {classes} = this.props;
        const {suggestions, tags} = this.state;

        return (
            <ReactTags tags={tags}
                       suggestions={suggestions}
                       handleDelete={this.handleDelete}
                       handleAddition={this.handleAddition}
                       handleDrag={this.handleDrag}
                       placeholder="Search Patient"
                       handleInputChange={this.getSuggestions}
                       delimiters={delimiters}/>
        );
    }
}

AutoCompletePatientForCampaign.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AutoCompletePatientForCampaign);



// WEBPACK FOOTER //
// ./src/components/Search/AutoCompletePatientForCampaign.jsx